import { useParams, Link } from 'react-router-dom';
import { categories, videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryVideos = videos.filter((v) => v.category === slug);

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <i className="ri-error-warning-line text-5xl text-foreground-400 mb-4 block"></i>
          <p className="text-foreground-600 text-lg">分类不存在</p>
          <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const pageTitle = `${category.name} - 嫩草视频高清在线观看 | ${category.description}`;
  const pageDesc = `嫩草视频${category.name}频道，${category.description}。海量${category.name}资源在线观看，高清画质流畅不卡顿，手机网页版即点即看。`;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: pageTitle,
    description: pageDesc,
    url: `https://www.nencaovideo.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '嫩草视频',
      url: 'https://www.nencaovideo.com',
    },
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={`${category.name},嫩草视频,在线观看,高清,不卡,网页版,手机看`}
        canonicalUrl={`https://www.nencaovideo.com/category/${slug}`}
        ogTitle={pageTitle}
        ogDescription={pageDesc}
        ogType="website"
        ogUrl={`https://www.nencaovideo.com/category/${slug}`}
        schema={schema}
      />

      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: category.name },
        ]}
      />

      <main className="w-full px-4 md:px-6 py-8">
        <div className="max-w-[1200px] mx-auto">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <i className={`${category.icon} text-xl text-primary-600`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
                {category.name}
              </h1>
            </div>
            <p className="text-foreground-500 text-sm ml-[52px]">{category.description}</p>
          </div>

          <div className="flex items-center gap-2 mb-6 flex-wrap">
            <span className="text-sm text-foreground-500 whitespace-nowrap">全部分类：</span>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-secondary-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryVideos.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
              {categoryVideos.map((video) => (
                <VideoCard key={video.id} {...video} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-5xl text-foreground-300 block mb-4"></i>
              <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}